import React from "react";
import EOpticAndCameraFeature from "../../../Model/EOpticAndCameraFeature";
import {
  UltravioletCaptureProperty,
  UltravioletFluorescenceCaptureProperty,
  VisibleCaptureProperty,
  VisibleFluorescenceCaptureProperty,
} from "../../../Model/CaptureProfile";
import { Gamma } from "../../../Model/ImagerCapabilities";
import { BasicControl } from "../ImagerFeatureControls";

type GammaControlProps = {
  disabled: boolean;
  gamma: Gamma;
  captureProperty:
    | VisibleCaptureProperty
    | VisibleFluorescenceCaptureProperty
    | UltravioletCaptureProperty
    | UltravioletFluorescenceCaptureProperty;
  onChange: (value: { gamma: number }) => void;
};

export function GammaControl({ gamma, captureProperty, disabled, onChange }: GammaControlProps) {
  if (captureProperty.gamma == null) {
    throw new Error("Capture profile gamma is null");
  }
  return (
    <BasicControl
      disabled={disabled}
      feature="Gamma"
      id={EOpticAndCameraFeature.Gamma}
      min={gamma.minGamma}
      max={gamma.maxGamma}
      value={captureProperty.gamma}
      onValueChanged={(id, value) => {
        onChange({
          gamma: value,
        });
      }}
      unit=""
      step={0.1}
    />
  );
}
